<template>
    <div class="layout">
        <aside class="sidebar" :class="{ collapsed: isCollapsed }">
            <ul>          
                <li @click="toggleMenu">
                    <img :src="menuIcon" alt="Toggle Menu" />
                    <span>{{ isCollapsed ? 'Expandir' : 'Recolher' }}</span>
                </li>

                <li v-if="globalStore.ckperfilrt" @click="setComponenteAtivo('EstabelecimentosRtTabPage', 'ESTABELECIMENTOS')">
                    <img src="@/assets/icons/menuIndustry.svg" />
                    <span>Estabelecimentos</span>
                </li>

                <li @click="setComponenteAtivo('Pla06TabPage', 'VISTORIAS')">
                    <img src="@/assets/icons/menuVistorias.png" />
                    <span>Tabela de Vistorias</span>
                </li>

                <li @click="setComponenteAtivo('Pla01TabPage', 'COLETAS')">
                    <img src="@/assets/icons/menuColetas.png" />
                    <span>Tabela de Coletas</span>
                </li>


                <li @mouseover="showPlanilhasMenu = true" @mouseleave="showPlanilhasMenu = false">
                    <img src="@/assets/icons/menuTable.svg" />
                    <span>Planilhas</span>
                    <div v-if="showPlanilhasMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul>
                            <li @click="selectOption('PlaMpTabPage', 'PLANILHAS DE MATÉRIA PRIMA')">
                                <span>Matéria Prima</span>
                            </li>
                            <li v-if="globalStore.atividade.ckmpleite" @click="selectOption('PlaLeiteTabPage', 'PLANILHAS DE LEITE')">
                                <span>Leite</span>
                            </li>
                            <li v-if="globalStore.atividade.ckmpmel" @click="selectOption('PlaMelTabPage', 'PLANILHAS DE MEL')">
                                <span>Mel</span>
                            </li>
                            <li @click="selectOption('PlaProducaoTabPage', 'PLANILHAS DE PRODUÇÃO')">
                                <span>Produção</span>
                            </li>
                            <li @click="selectOption('PlaExpedicaoTabPage', 'PLANILHAS DE EXPEDIÇÃO')">
                                <span>Expedição</span>
                            </li>
                            
                            <li @click="selectOption('DocAnulacaoEstabelecimentosTabPage', 'ESTORNO DE PLANILHAS')">
                                <span>Estorno de Planilhas Homologadas</span>
                            </li>
                        </ul>
                    </div>
                </li>
                

                <li @mouseover="showRACMenu = true" @mouseleave="showRACMenu = false">
                    <img src="@/assets/icons/menuRAC.png" />
                    <span>R.A.C.</span>
                    <div v-if="showRACMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul><li @click="selectOption('Pla08PendenteTabPage', 'R.A.C. PENDENTES')">
                            <span>Pendentes</span>
                        </li></ul>

                        <ul><li @click="selectOption('Pla08TabPage', 'R.A.C. FINALIZADOS')">
                            <span>Finalizados</span>
                        </li></ul>
                    </div>
                </li>

                <li @mouseover="showRelatoriosMenu = true" @mouseleave="showRelatoriosMenu = false">
                    <img src="@/assets/icons/menuPrinter.png" />
                    <span>Relatórios</span>
                    <div v-if="showRelatoriosMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul><li @click="selectOption('ColetaNCAnaliticoReportPage', 'RELATÓRIO: COLETAS / NÃO CONFORMIDADES')">
                            <span>Coletas - Não Conformidades</span>
                        </li></ul>
                        
                        <ul><li @click="selectOption('EstebelecimentosParecerReportPage', 'RELATÓRIO: PARECER ESTABELECIMENTOS')">
                            <span>Estabelecimentos - Parecer Analítico</span>
                        </li></ul>

                        <ul><li @click="selectOption('NCAnaliticoReportPage', 'RELATÓRIO: ANALÍTICO DE NÃO CONFORMIDADES')">
                            <span>Não Conformidades - Analítico</span>
                        </li></ul>
                    </div>
                </li>


                <li @mouseover="showParametrosMenu = true" @mouseleave="showParametrosMenu = false">
                    <img src="@/assets/icons/menuSettings.svg" />
                    <span>Parametrizações</span>
                    <div v-if="showParametrosMenu" class="submenu" :class="{ 'relative': isCollapsed }">
                        <ul><li @click="selectOption('EstabelecimentosCliTabPage', 'CADASTRO DE COMPRADORES')">
                            <span>Cadastro de Compradores</span>
                        </li></ul>

                        <ul><li @click="selectOption('EstabelecimentosCpProducaoPage', 'CAPACIDADE DE PRODUÇÃO DIÁRIA')">
                            <span>Capacidade de Produção</span>
                        </li></ul>

                        <ul><li @click="selectOption('EstabelecimentoProdutoMapaConfigPage', 'CONFIGURAÇÃO PRODUTOS MAPA')">
                            <span>Configuração Produtos</span>
                        </li></ul>
                    </div>
                </li>


                <li @click="setComponenteAtivo('UsuarioViewPage', 'USUÁRIO')">
                    <img src="@/assets/icons/menuEditUser.png" />
                    <span>Usuário</span>
                </li>

                <li class="logout" @click="confirmLogout">
                    <img src="@/assets/icons/menuLogout.png" />
                    <span>Desconectar</span>
                </li>
            </ul>
        </aside>


        <main class="content">
            <header class="header">
                <div class="header-title">{{ nmTitulo || nmPerfil }}</div>
                <div style="align-items: center; display: flex;">
                    <div class="user-info">
                        <div class="user-name">{{ globalStore.nmusuario }}</div>
                        <div class="establishment-name">{{ globalStore.nmestabelecimento }}</div>
                    </div>
                    <div class="token-info">{{ timeRemaining }}</div>
                </div>
            </header>
            <div class="main-content">
                <slot>
                    <div v-if="nmComponenteAtivo=='EstabelecimentosRtTabPage'"><EstabelecimentosRtTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='Pla01TabPage'"><Pla01TabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='Pla06TabPage'"><Pla06TabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='RotulosEstabListaPage'"><RotulosEstabListaPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='RtViewPage'"><RtViewPage/></div>
                    <div v-else-if="nmComponenteAtivo=='UsuarioViewPage'"><UsuarioViewPage :idView=globalStore.idusuario @close="setComponenteAtivo(null, null)"/></div>
                    

                    <div v-else-if="nmComponenteAtivo=='EstabelecimentoProdutoMapaConfigPage'"><EstabelecimentoProdutoMapaConfigPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EstabelecimentosCpProducaoPage'"><EstabelecimentosCpProducaoPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EstabelecimentosCliTabPage'"><EstabelecimentosCliTabPage @close="setComponenteAtivo(null, null)"/></div>
                    

                    <div v-else-if="nmComponenteAtivo=='DocAnulacaoEstabelecimentosTabPage'"><DocAnulacaoEstabelecimentosTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaExpedicaoTabPage'"><PlaExpedicaoTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaLeiteTabPage'"><PlaLeiteTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaMelTabPage'"><PlaMelTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaMpTabPage'"><PlaMpTabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='PlaProducaoTabPage'"><PlaProducaoTabPage @close="setComponenteAtivo(null, null)"/></div>
                    

                    <div v-else-if="nmComponenteAtivo=='Pla08TabPage'"><Pla08TabPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='Pla08PendenteTabPage'"><Pla08PendenteTabPage @close="setComponenteAtivo(null, null)"/></div>


                    <div v-else-if="nmComponenteAtivo=='ColetaNCAnaliticoReportPage'"><ColetaNCAnaliticoReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='EstebelecimentosParecerReportPage'"><EstebelecimentosParecerReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else-if="nmComponenteAtivo=='NCAnaliticoReportPage'"><NCAnaliticoReportPage @close="setComponenteAtivo(null, null)"/></div>
                    <div v-else></div>
                </slot>
            </div>
        </main>
    </div>
</template>


<script setup>
import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';
import { jwtDecode } from 'jwt-decode';
import { useRouter } from 'vue-router';
import EstabelecimentosRtTabPage from '@/views/cadastros/tabelas/EstabelecimentosRtTabPage.vue';
import Pla01TabPage from '@/views/planilhas/tabelas/Pla01TabPage.vue';
import Pla06TabPage from '@/views/planilhas/tabelas/Pla06TabPage.vue';
import RotulosEstabListaPage from '../operacoes/RotulosEstabListaPage.vue';
import RtViewPage from '@/components/cadastros/views/RtViewPage.vue';
import UsuarioViewPage from '@/views/cadastros/visualizacoes/UsuarioViewPage.vue';

// SUBMENU CONFIGURAÇÕES
import EstabelecimentosCpProducaoPage from '@/views/cadastros/tabelas/EstabelecimentosCpProducaoPage.vue';
import EstabelecimentoProdutoMapaConfigPage from '@/views/cadastros/tabelas/EstabelecimentoProdutoMapaConfigPage.vue';
import EstabelecimentosCliTabPage from '@/views/cadastros/tabelas/EstabelecimentosCliTabPage.vue';

// SUBMENU PLANILHAS
import DocAnulacaoEstabelecimentosTabPage from '@/views/docs/tabelas/DocAnulacaoEstabelecimentosTabPage.vue';
import PlaExpedicaoTabPage from '@/views/planilhas/tabelas/PlaExpedicaoTabPage.vue';
import PlaLeiteTabPage from '@/views/planilhas/tabelas/PlaLeiteTabPage.vue';
import PlaMelTabPage from '@/views/planilhas/tabelas/PlaMelTabPage.vue';
import PlaMpTabPage from '@/views/planilhas/tabelas/PlaMpTabPage.vue';
import PlaProducaoTabPage from '@/views/planilhas/tabelas/PlaProducaoTabPage.vue';

// SUBMENU RAC
import Pla08TabPage from '@/views/planilhas/tabelas/Pla08TabPage.vue';
import Pla08PendenteTabPage from '@/views/planilhas/tabelas/Pla08PendenteTabPage.vue';

// SUBMENU RELATÓRIOS
import ColetaNCAnaliticoReportPage from '../reports/ColetaNCAnaliticoReportPage.vue';
import EstebelecimentosParecerReportPage from '../reports/EstebelecimentosParecerReportPage.vue';
import NCAnaliticoReportPage from '../reports/NCAnaliticoReportPage.vue';

const isCollapsed = ref(true);
const nmComponenteAtivo = ref(null);
const nmPerfil = ref('ESTABELECIMENTO/RT');
const nmTitulo = ref(null);
const router = useRouter();
const showParametrosMenu = ref(false);
const showPlanilhasMenu = ref(false);
const showRACMenu = ref(false);
const showRelatoriosMenu = ref(false);
const timeRemaining = ref(null);
let timer = null;


const menuIcon = computed(() =>
    isCollapsed.value
        ? require('@/assets/icons/menuExpand.svg')
        : require('@/assets/icons/menuCollapse.svg')
);


const confirmLogout = () => {resetLogin();}

const resetLogin = () => {
    Api.logoutAPI();
    router.push('/login');
}

const selectOption = (page, titulo) => {
    nmComponenteAtivo.value = page;
    nmTitulo.value = titulo;
    showParametrosMenu.value = false;
    showPlanilhasMenu.value = false;
    showRACMenu.value = false;
    showRelatoriosMenu.value = false;
}

const setComponenteAtivo = (nome, titulo) => {
    nmComponenteAtivo.value = nome;
    nmTitulo.value = titulo;
}

const toggleMenu = () => {isCollapsed.value = !isCollapsed.value;}

const updateTimeRemaining = () => {
    const token = localStorage.getItem('jwtToken');
    if (token){
        try{
            const decodedToken = jwtDecode(token);
            const expiration = decodedToken.exp * 1000;
            const now = Date.now();
            const difference = expiration - now;

            if (difference > 0){
                const hours         = Math.floor((difference / (1000 * 60 * 60)) % 24);
                const minutes       = Math.floor((difference / (1000 * 60)) % 60);
                const seconds       = Math.floor((difference / 1000) % 60);
                const formattedTime = [
                    hours.toString().padStart(2, '0'),
                    minutes.toString().padStart(2, '0'),
                    seconds.toString().padStart(2, '0')
                ].join(':');
                timeRemaining.value = formattedTime;
            }else{
                timeRemaining.value = "Token expirado";
                clearInterval(timer);
                // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
            }
        }catch(error){
            console.error('Erro ao decodificar o token:', error);
            timeRemaining.value = "Erro ao verificar o token";
            clearInterval(timer);
        }
    } else {
        timeRemaining.value = "Token não encontrado";
        clearInterval(timer);
        // TODO: REDIRECIONAR PARA TELA DE LOGIN OU EMITIR ALERTA E REATIVAR A SESSÃO
    }
};

onMounted(() => {
    nmPerfil.value = (globalStore.ckperfilrt) ? 'RESPONSÁVEL TÉCNICO' : 'ADMINISTRADOR ESTABELECIMENTO';
    updateTimeRemaining();
    timer = setInterval(updateTimeRemaining, 1000);
});

onBeforeUnmount(() => {
    clearInterval(timer);
});
</script>